module.exports = __webpack_public_path__ + "img/cysuccess.9220f802.png";